import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { FormikErrors, useFormik } from 'formik'
import React from 'react'
import { Control, House } from '../../types'
import { pinValidate } from '../../utils/businessUtil'
import { PinIndicator, getUsedPins } from '../ControlForm/PinIndicator'

export type DenjiFormFields = {
	label: string
	activePin: number | null // ON/OFF する制御ピン
}

type Props = {
	disabled: boolean
	handleSubmit: (fields: DenjiFormFields) => void
	house?: House
	existingControls?: Control[]
}

// 電磁弁 (denji) の作成フォーム。デバイス登録（label + 制御ピン）のみ。
// 24時間の ON/OFF ルールはシナリオ側 (DenjiManageTab) で設定する。
function DenjiForm(props: Props) {
	const {
		values,
		errors,
		touched,
		handleChange,
		handleSubmit,
		setFieldTouched,
		setFieldValue,
	} = useFormik<DenjiFormFields>({
		initialValues: {
			label: '電磁弁',
			activePin: null,
		},
		validate: (values) => {
			const errors: FormikErrors<DenjiFormFields> = {}

			if (!values.label) {
				errors.label = '必須です。'
			}
			if (pinValidate(values.activePin) || !values.activePin) {
				errors.activePin = '制御ピンを1から16の値で設定してください。'
			}

			return errors
		},
		onSubmit: (fields) => {
			props.handleSubmit(fields)
		},
	})

	const change = (
		name: keyof DenjiFormFields,
		e: React.ChangeEvent<unknown>,
	) => {
		e.persist()
		handleChange(e)
		setFieldTouched(name, true, false)
	}

	const { usedPins, twayPins } = getUsedPins(props.existingControls || [])

	return (
		<div>
			<Typography>電磁弁機器を作成</Typography>
			<Typography variant="caption" color="text.secondary">
				24時間の ON/OFF ルールは、作成後にシナリオ側で設定します。
			</Typography>
			<form style={{ display: 'grid', gap: '8px', marginTop: '8px' }}>
				<TextField
					name="label"
					type="text"
					autoComplete="pf-label"
					error={touched.label && Boolean(errors.label)}
					required
					disabled={props.disabled}
					label="名前"
					helperText={touched.label && errors.label}
					value={values.label}
					inputProps={{ 'data-test': 'denji-input-label' }}
					onChange={change.bind(null, 'label')}
					fullWidth
				/>
				<TextField
					name="activePin"
					type="number"
					autoComplete="pf-activePin"
					error={touched.activePin && Boolean(errors.activePin)}
					required
					disabled={props.disabled}
					label="制御ピン(1~16)"
					helperText={touched.activePin && errors.activePin}
					value={values.activePin}
					inputProps={{ 'data-test': 'denji-input-activePin' }}
					onChange={change.bind(null, 'activePin')}
					fullWidth
				/>
				<PinIndicator
					usedPins={usedPins}
					twayPins={twayPins}
					house={props.house}
					selectedPins={
						values.activePin != null ? new Set([values.activePin]) : new Set()
					}
					onPinClick={(pin) => {
						setFieldValue('activePin', values.activePin === pin ? null : pin)
						setFieldTouched('activePin', true, false)
					}}
				/>
				<Button
					variant="contained"
					color="primary"
					onClick={() => handleSubmit()}
					disabled={props.disabled}
					size={'large'}
				>
					追加する
				</Button>
			</form>
		</div>
	)
}

export default DenjiForm
